<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Subir archivo de cargas</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-padding-bottom">
      <ion-col size="12">
        <lib-file-drop-area
          [acceptFormats]="'image/jpeg,application/pdf'"
          (fileToParentComponent)="uploadCompanyDocumentAsFile($event)"
          [hideButton]="true"
        ></lib-file-drop-area>
      </ion-col>

      @if (errorMessage()) {
        <ion-col size="12">
          <div class="errors">
            {{ errorMessage() }}
          </div>
        </ion-col>
      }
    </ion-row>
    <ion-row>
      <ion-col>
        <a
          href="assets/templates/Envios_cargador.xlsx"
          download
        >
          Archivo de cargas de ejemplo
        </a>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            {{ 'general.save' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
